export const fileTypeAllow = [
  "pdf",
  "csv",
  "txt",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "jpg",
  "jpeg",
  "png",
];

/** `accept` attribute value for a file input restricted to `fileTypeAllow`. */
export const fileTypeAllowed = fileTypeAllow.map((type) => "." + type).join(",");
